import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, ArrowRight } from "lucide-react";

const Footer = () => {
  const cities = [
    { name: "Bengaluru", slug: "bengaluru" },
    { name: "Mumbai", slug: "mumbai" },
    { name: "Hyderabad", slug: "hyderabad" },
    { name: "Chennai", slug: "chennai" },
    { name: "Pune", slug: "pune" },
    { name: "Delhi-NCR", slug: "delhi-ncr" },
  ];

  const categories = [
    { name: "New Launches", slug: "new_launch" },
    { name: "Under Construction", slug: "under_construction" },
    { name: "Ready to Move", slug: "ready_to_move" },
  ];

  return (
    <footer className="bg-stone-900 text-white" data-testid="footer">
      {/* CTA Strip */}
      <div className="bg-emerald-900 py-12">
        <div className="section-container">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="font-display text-2xl md:text-3xl mb-2">Find Your Dream Home Today</h3>
              <p className="text-emerald-100/80">100% RERA Verified Projects. Zero Brokerage.</p>
            </div>
            <Link
              to="/search"
              className="bg-white text-emerald-900 px-8 py-4 text-sm uppercase tracking-widest font-medium hover:bg-stone-50 transition-colors flex items-center gap-2"
              data-testid="footer-search-btn"
            >
              Explore Properties <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </Link>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="section-container py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="font-display text-2xl mb-4">
              RERA <span className="text-amber-500">Approved</span>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed mb-6">
              India's most trusted platform for RERA-verified residential properties. Zero brokerage. Complete transparency.
            </p>
            <div className="space-y-3 text-sm">
              <a href="mailto:hello@reraapproved.in" className="flex items-center gap-2 text-stone-400 hover:text-white transition-colors">
                <Mail className="w-4 h-4" strokeWidth={1.5} />
                hello@reraapproved.in
              </a>
              <a href="tel:+919740899729" className="flex items-center gap-2 text-stone-400 hover:text-white transition-colors">
                <Phone className="w-4 h-4" strokeWidth={1.5} />
                +91 97408 99729
              </a>
            </div>
          </div>

          {/* Cities */}
          <div>
            <h4 className="font-medium text-sm uppercase tracking-widest text-stone-400 mb-4">Cities</h4>
            <ul className="space-y-2">
              {cities.map((city) => (
                <li key={city.slug}>
                  <Link
                    to={`/city/${city.slug}`}
                    className="text-stone-300 hover:text-white text-sm transition-colors flex items-center gap-1"
                  >
                    <MapPin className="w-3 h-3" strokeWidth={1.5} />
                    {city.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-medium text-sm uppercase tracking-widest text-stone-400 mb-4">Property Type</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/search?category=${cat.slug}`}
                    className="text-stone-300 hover:text-white text-sm transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/emi-calculator" className="text-stone-300 hover:text-white text-sm transition-colors">
                  EMI Calculator
                </Link>
              </li>
              <li>
                <Link to="/compare" className="text-stone-300 hover:text-white text-sm transition-colors">
                  Compare Properties
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-medium text-sm uppercase tracking-widest text-stone-400 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/search" className="text-stone-300 hover:text-white text-sm transition-colors">
                  Search Properties
                </Link>
              </li>
              <li>
                <Link to="/search?featured=true" className="text-stone-300 hover:text-white text-sm transition-colors">
                  Featured Projects
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-stone-300 hover:text-white text-sm transition-colors">
                  Blog & Guides
                </Link>
              </li>
              <li>
                <a href="#" className="text-stone-300 hover:text-white text-sm transition-colors">
                  About RERA
                </a>
              </li>
              <li>
                <a href="#" className="text-stone-300 hover:text-white text-sm transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-stone-800">
        <div className="section-container py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-stone-500">
            <p>&copy; {new Date().getFullYear()} RERA Approved. All rights reserved.</p>
            <div className="flex items-center gap-6">
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-white transition-colors">RERA Compliance</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
